import React, { useState } from "react";
import * as s from "./index.module.scss";
import { IoArrowForward } from "react-icons/io5";
import secondaryFont from "@/utils/secondaryFont";
import Link from "next/link";
import Popups from "@/components/Common/Popups";
import { PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";

const Collateral = ({ data, page = "" }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <section className={s.collateral}>
      <div className={s.collateral_wrapper}>
        <article className={s.image_container}>
          {/* <img loading="lazy" src={CollateralImage.src} alt="image" /> */}
          <PrismicNextImage
            className="h-100"
            loading="lazy"
            field={data?.image}
            fallbackAlt=""
          />
        </article>
        <article className={s.text_container}>
          <h4 className="heading fw-bold">{data?.title}</h4>

          <PrismicRichText
            field={data?.subTitle}
            components={{
              heading2: ({ children }) => <h3>{children}</h3>,
              heading3: ({ children }) => <h3>{children}</h3>,
            }}
          />
          <div className="sub-title">
            <PrismicRichText field={data?.text} />
          </div>

          <div className={s.button_container}>
            <button
              className={`btn btn-mob-pad btn-primary mb-md-0 me-3 ${secondaryFont}`}
              onClick={() => {
                setShowModal(true);
              }}
            >
              Get a loan offer now{" "}
              <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
            </button>
            <Link
              href="/collateral-loans"
              className={`btn btn-mob-pad btn-outline-dark ${secondaryFont}`}
            >
              View More{" "}
              <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
            </Link>
          </div>
        </article>
      </div>
      <Popups
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        offer={true}
        page={page}
      />
    </section>
  );
};

export default Collateral;
